import type {AddSupplierFunctionFormPayload} from "./add-supplier-function.schema";

import {addSupplierFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

export function addSupplierFunctionMutationOptions(supplierId: string) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.addSupplierFunction,
    mutationFn: (payload: AddSupplierFunctionFormPayload) =>
      addSupplierFunction(supplierId, payload),
    onSuccess: async (_functionId, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
